module.exports = __webpack_public_path__ + "static/bg-invite.94eac125.png";